<template>
  <v-container class="euryale-chronicles card-style mb-4">
    <!-- Листы -->
    <v-tabs v-model="tab" 
        color="#00b8d4" dark 
        next-icon="mdi-arrow-right-bold-box-outline <" 
        prev-icon="mdi-arrow-left-bold-box-outline >" 
        centered grow show-arrows>
      <!-- vertical -->
      <!-- #ff7100 -->
      <v-tab v-for="item in chronicles" :key="item.sheetName">
        {{ item.sheetName }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" flat>
      <!-- Процесс загрузки -->
      <!-- Ошибка загрузки -->
      <p v-if="loadingError" class="text-center">Не удалось загрузить данные =(</p>
      <!-- Загрузка -->
      <v-img v-if="loading" class="mx-auto" width='200px' :src="require('@/assets/animate-logo-white.svg')" />
      <!--  -->
      <v-tab-item v-for="(item, i) in chronicles" :key="item.sheetName">
        <v-card class="px-4" flat>
          <!-- Записи -->
          <template v-if="i == 0">
            <v-timeline :dense="isMobile">
              <v-timeline-item v-for="record in item.data" :key="record[0]" :color="'#1e1e1e'" right large>
                <template v-slot:icon>
                  <v-avatar>
                    <img :src="require('@/assets/animate-logo-white.svg')">
                  </v-avatar>
                </template>
                <template v-if="!isMobile" v-slot:opposite>
                  <span class="headline font-weight-bold cyan--text accent-4">
                    {{((''+record[0]).split(/\T\d{2}/))[0]}}
                  </span>
                </template>
                <v-card class="elevation-2">
                    <!-- <v-card class="elevation-2 card-style"> -->
                    <v-card-title v-if="isMobile" class="headline font-weight-bold cyan--text accent-4">
                        {{((''+record[0]).split(/\T\d{2}/))[0]}}
                    </v-card-title>
                  <v-card-text class="euryale-text">{{ record[1] }}</v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </template>
          <!--  -->
          <template v-else>
            <v-tabs v-model="date[i]" color="#00b8d4" dark 
                next-icon="mdi-arrow-right-bold-box-outline <" 
                prev-icon="mdi-arrow-left-bold-box-outline >" 
                show-arrows>
              <v-tab v-for="record in item.data" :key="record[0]">
                {{ ((''+record[0]).split(/\T\d{2}/))[0] }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="date[i]" flat>
              <v-tab-item v-for="record in item.data" :key="record[0]">
                <v-card flat>
                  <v-card-text>
                    
                    <template v-if="record[2]">
                        <template v-if="isMobile">
                            <v-img contain
                            class="rounded"
                            :lazy-src="require('@/assets/animate-logo-white.svg')"
                            :src="record[2]" />
                        </template>
                        <template v-else>
                            <v-img contain
                            class="rounded float-left mr-5 mb-1"
                            width="50%"
                            :lazy-src="require('@/assets/animate-logo-white.svg')"
                            :src="record[2]" />
                        </template>
                    </template>
                    
                    <p class="euryale-text">{{ record[1] }}</p>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </template>
          <!--  -->
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <!--  -->
  </v-container>
</template>


<script>
export default {
    props: ['isMobile'],
    data: () => ({
        loading: true,
        loadingError: false,
        chronicles: Array,
        // data: Array,
        tab: '',
        date: []
    }),
    created() {
        let url = process.env.VUE_APP_LINK_EURYALE;
        fetch(url)
            .then((response) => {
                if (response.ok) {
                    return response.json(); 
                }
                throw new Error('Network response was not ok');
              })
            .then((json) => {
                this.chronicles = json.result;
                this.loading = false;
            })
            .catch((error) => {
                this.loadingError = true;
                console.log(error);
            });
    },
}
</script>

<style scoped>
    .euryale-text {
        letter-spacing: 0.05em !important;
        font-size: 1rem !important;
        white-space: pre-wrap;
    }
    
    .euryale-text::first-letter {
      color: rgb(0, 184, 212);
      font-size: 2rem;
      /*background-color: rgb(0, 184, 212);*/
    }

</style>